export const initialState = {
    useCaseValue: "",
    selectedSubUseCases: [],
    selectedCredType: "",
    certificateExpiryDate: "",
    uploading: false,
    status: {isVisible: false, type: null, message: ""},
};

export function formReducer(state, action) {
    switch (action.type) {
        case 'SET_USE_CASE':
            return {
                ...initialState,
                useCaseValue: action.payload.useCaseValue,
            };
        case 'SET_SUB_USE_CASES':
            return {
                ...state,
                selectedSubUseCases: action.payload,
            };
        case 'SET_FILE_TYPE':
            return {
                ...state,
                selectedCredType: action.payload,
                certificateExpiryDate: "",
                uploading: false,
                status: {isVisible: false, type: null, message: ""},
            };
        case 'SET_EXPIRY_DATE':
            return {
                ...state,
                certificateExpiryDate: action.payload,
            };
        case 'SET_STATUS':
            return {
                ...state,
                status: action.payload,
            };
        case 'SET_UPLOADING':
            return {
                ...state,
                uploading: action.payload,
            };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}